// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eMHR","field":"styles_field__2w95A","fieldCol":"styles_fieldCol__3-Xjm","diffCol":"styles_diffCol__1UlCH","diff":"styles_diff__1nILd"};